import facilityEditData from './facility-edit-editable-fields.json';

class FacilityEditFormService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;

        this.fields = undefined;
        this.facilityFieldMap = {};
    }

    configureFacilityFieldMap(fields) {
        for (let field of fields) {
            this.facilityFieldMap[field.name] = field;
        }
    }

    /***
     * Returns a list of editable form fields for the Facility Edit Form.  Any fields not listed here  will
     *  be displayed as read-only fields when the Facility Edit Form is rendered.
     *
     * @returns {array}
     */
    getEditableFields() {
        return facilityEditData.editableFields;
    }


    /***
     * Fetch all of the FacilitySettings from the API. These represent the metadata about the various form fields that
     * are rendered on the Facility Settings page.
     *
     * If the FacilitySettings have already been fetched once, then we return the locally stored version, since they
     * are unlikely to change.
     *
     * @returns {Promise | array}
     */
    getFacilityFields() {
        if (this.fields !== undefined) {
            return this.fields;
        }
        return this.$http.get(`${this.appConfig.apiUrl}/facilities/fields/`)
            .then((successResponse) => {
                this.fields = successResponse.data;
                this.configureFacilityFieldMap(this.fields);
                return this.fields;
            });
    }

    /***
     * Fetch the latest FacilitySettingValues for the provided client. The data is returned as a JSON object mapping
     * field names to their value.
     *
     * @param facilityId        the ID of the facility whose settings are being fetched
     * @param month             the month representing the effective date of the settings being fetched
     * @param year              the year representing the effective date of the settings being fetched
     *
     * @returns {object}
     */
    getFacilitySettings(facilityId, month, year) {
        const d = new Date();
        month = month === undefined ? d.getMonth() + 1 : month;
        year = year === undefined ? d.getFullYear() : year;
        const config = {
            params: {
                month: month,
                year: year
            }
        };
        return this.$http.get(`${this.appConfig.apiUrl}/facilities/${facilityId}/settings/`, config)
            .then((successResponse) =>  successResponse.data);
    }

    /***
     * Save the updated Facility Settings for the given facility.
     *
     * @param facilityId        the ID of the facility being updated.
     * @param data              an object containing 3 keys:
     *                          month - the month for the effective date of the data being saved
     *                          year - the year for the effective date of the data being saved
     *                          name (optional) - an updated name for this Facility
     *                          facility_setting_values - all of the updated values for this Facility.
     *
     * @returns {Promise}
     */
    updateFacilitySettings(facilityId, data) {
        return this.$http.post(`${this.appConfig.apiUrl}/facilities/${facilityId}/settings/`, data);
    }

    /***
     * Create a new facility-practitioner assignment for the given facility and practitioner
     *
     * @param facilityId            the ID of the facility being assigned
     * @param practitionerId        the ID of the practitioner being assigned
     */
    addPractitionerToFacility(facilityId, practitionerId) {
        const data = {
            practitioner_id: practitionerId,
            facility_id: facilityId
        };
        return this.$http.post(`${this.appConfig.apiUrl}/facilities/${facilityId}/practitioners/`, data)
            .then((successResponse) => successResponse.data);
    }

}

export default FacilityEditFormService;


// WEBPACK FOOTER //
// ./app/components/client-edit/facility-edit-form/facility-edit-form-service.js